"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var messages = exports.messages = function messages(locale) {
  if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object' && window.__YKB_UI_LOCALE__ && window.__YKB_UI_LOCALE__.locale === 'en') {
    return {
      default: 'Validation error on field %s',
      required: function required(name) {
        return "Required field";
      },
      enum: '%s must be one of %s',
      whitespace: function whitespace(name) {
        return "Cannot be empty";
      },
      date: {
        format: '%s date %s is invalid for format %s',
        parse: '%s date could not be parsed, %s is invalid ',
        invalid: '%s date %s is invalid'
      },
      types: {
        string: '%s is not a %s',
        method: '%s is not a %s (function)',
        array: '%s is not an %s',
        object: '%s is not an %s',
        number: function number(name, val) {
          return "Is not a number";
        },
        date: function date(name, val) {
          return "Is not a date";
        },
        boolean: '%s is not a %s',
        integer: '%s is not an %s',
        float: '%s is not a %s',
        regexp: '%s is not a valid %s',
        email: function email(name, val) {
          return "Is not a valid email";
        },
        url: '%s is not a valid %s',
        hex: '%s is not a valid %s'
      },
      string: {
        len: function len(name, val) {
          return "Must be exactly ".concat(val, " characters");
        },
        min: function min(name, val) {
          return "Must be at least ".concat(val, " characters");
        },
        max: function max(name, val) {
          return "Cannot be longer than ".concat(val, " characters");
        },
        range: function range(name, val1, val2) {
          return "Must be between ".concat(val1, " and ").concat(val2, " characters");
        }
      },
      number: {
        len: function len(name, val) {
          return "Must equal ".concat(val);
        },
        min: function min(name, val) {
          return "Cannot be less than ".concat(val);
        },
        max: function max(name, val) {
          return "can not be greater than ".concat(val);
        },
        range: function range(name, val1, val2) {
          return "Must be between ".concat(val1, " and ").concat(val2);
        }
      },
      array: {
        len: '%s must be exactly %s in length',
        min: '%s cannot be less than %s in length',
        max: '%s cannot be greater than %s in length',
        range: '%s must be between %s and %s in length'
      },
      pattern: {
        mismatch: '%s value %s does not match pattern %s'
      },
      custom: {
        tckn: 'Identity number is invalid'
      }
    };
  }
  return {
    default: '%s alanını kontrol ediniz',
    required: function required(name) {
      return "Zorunlu aland\u0131r";
    },
    enum: '%s alanı sadece bu değerleri alabilir: %s',
    whitespace: function whitespace(name) {
      return "Ge\xE7erli bir karakter giriniz";
    },
    date: {
      format: '%s date %s geçerli bir %s formatı değil',
      parse: '%s tarihi çözümlenemedi, %s geçerli değil',
      invalid: '%s date %s geçerli değil'
    },
    types: {
      string: '%s bir %s değil',
      method: '%s bir %s değil (function)',
      array: '%s bir %s değil',
      object: '%s bir %s değil',
      number: function number(name, val) {
        return "N\xFCmerik de\u011Fer giriniz";
      },
      date: function date(name, val) {
        return "Tarih format\u0131nda giriniz";
      },
      boolean: '%s bir %s değil',
      integer: '%s bir %s değil',
      float: '%s bir %s değil',
      regexp: '%s geçerli bir %s değil',
      email: function email(name, val) {
        return "E-posta format\u0131nda giriniz";
      },
      url: '%s geçerli bir %s değil',
      hex: '%s geçerli bir %s değil',
      tckn: '%s geçerli bir %s değil'
    },
    string: {
      len: function len(name, val) {
        return "".concat(val, " karakter i\xE7ermelidir");
      },
      min: function min(name, val) {
        return "En az ".concat(val, " karakter i\xE7ermelidir");
      },
      max: function max(name, val) {
        return "En fazla ".concat(val, " karakter i\xE7ermelidir");
      },
      range: function range(name, val1, val2) {
        return "".concat(val1, " ile ").concat(val2, " aras\u0131nda karakter i\xE7ermelidir");
      }
    },
    number: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    }, "len", function len(name, val) {
      return "".concat(val, " rakam\u0131na e\u015Fit olmal\u0131d\u0131r");
    }), "min", function min(name, val) {
      return "".concat(val, " rakam\u0131ndan k\xFC\xE7\xFCk olamaz");
    }), "max", function max(name, val) {
      return "".concat(val, " rakam\u0131ndan b\xFCy\xFCk olamaz");
    }), "range", function range(name, val1, val2) {
      return "".concat(val1, " ile ").concat(val2, " aras\u0131nda olmal\u0131d\u0131r");
    }),
    array: {
      len: '%s tam olarak %s uzunluğunda olmalıdır (array length)',
      min: '%s en az %s uzunluğunda olabilir (array length)',
      max: '%s en fazla %s uzunluğunda olabilir (array length)',
      range: '%s %s ile %s arasında uzunlukta olabilir (array length)'
    },
    pattern: {
      mismatch: '%s value %s %s gibi şekillendirilmelidir (pattern)'
    },
    custom: {
      tckn: 'Kimlik numarası geçersizdir'
    }
  };
};